import { navigateTo } from '@app/core/routing';
import { Button, ButtonProps } from '@mui/material';
import React, { useState } from 'react';
import { ClickAbsorber } from './ClickAbsorber';

export interface ButtonLinkExternalProps extends Omit<ButtonProps, 'component' | 'href'> {
  readonly to: string;
  readonly openInNewTab?: boolean;
  readonly target?: string;
}

/**
 * MUI Button component that navigates to external URLs
 * This component prevents the double navigation issue that can occur with nested click handlers
 */
export const ButtonLinkExternal: React.FC<ButtonLinkExternalProps> = ({
  to,
  openInNewTab = false,
  target,
  children,
  onClick,
  disabled,
  ...rest
}) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!openInNewTab) {
      setIsDisabled(true);
    }

    if (onClick) {
      onClick(event);
    }

    if (openInNewTab) {
      window.open(to, target || '_blank');
    } else {
      navigateTo(to);
    }
  };

  return (
    <ClickAbsorber>
      <Button
        size="small"
        disabled={isDisabled || disabled}
        onClick={handleClick}
        loadingPosition="start"
        loading={isDisabled}
        {...rest}
      >
        {children}
      </Button>
    </ClickAbsorber>
  );
};
